import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import QRCodeGenerator from '../components/QRCodeGenerator';
import { SellerHeader } from '../components/SellerHeader';

// Style guide colors
const PRIMARY_BROWN = '#C97B53';
const NEUTRAL_BG = '#F9F9F9';
const NEUTRAL_WHITE = '#FFF';
const NEUTRAL_TEXT = '#222';
const ACCENT_GRAY = '#757575';

const headingFont = {
  fontFamily: 'Sora, sans-serif',
  fontWeight: 700,
};

const bodyFont = {
  fontFamily: 'Montserrat, sans-serif',
  fontWeight: 500,
};

export default function QRCodePage() {
  const { currentUser } = useAuth();

  return (
    <div style={{ 
      minHeight: '100vh', 
      background: NEUTRAL_BG,
      paddingBottom: '120px'
    }}>
      {/* Header */}
      <SellerHeader />

      {/* Main Content */}
      <div style={{ paddingTop: '72px' }}>
        <div style={{ 
          maxWidth: 600, 
          margin: '0 auto', 
          padding: '40px 20px'
        }}>
          {/* Page Header */}
          <div style={{ 
            textAlign: 'center', 
            marginBottom: 48 
          }}>
            <h1 style={{ 
              ...headingFont, 
              fontSize: 36, 
              color: NEUTRAL_TEXT, 
              margin: '0 0 20px 0' 
            }}>
              QR Code Generator
            </h1>
            <p style={{ 
              ...bodyFont, 
              fontSize: 18, 
              color: ACCENT_GRAY, 
              margin: '0 auto',
              maxWidth: 450,
              lineHeight: 1.5
            }}>
              Generate a QR code for your shop that customers can scan to visit your storefront
            </p>
          </div>

          {/* QR Code Generator */}
          <div style={{ 
            background: NEUTRAL_WHITE, 
            borderRadius: 20, 
            padding: 48, 
            boxShadow: '0 8px 32px rgba(0,0,0,0.12)',
            textAlign: 'center',
            margin: '0 auto',
            maxWidth: 500
          }}>
            <QRCodeGenerator storeId={currentUser?.uid} />
          </div>

          {/* Additional Info */}
          <div style={{ 
            marginTop: 48, 
            textAlign: 'center' 
          }}>
            <h3 style={{ 
              ...headingFont, 
              fontSize: 20, 
              color: NEUTRAL_TEXT, 
              margin: '0 0 24px 0' 
            }}>
              How to Use
            </h3>
            <div style={{ 
              display: 'grid', 
              gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', 
              gap: 32,
              marginTop: 32,
              maxWidth: 600,
              margin: '32px auto 0 auto'
            }}>
              <div style={{ textAlign: 'center' }}>
                <div style={{ 
                  width: 48, 
                  height: 48, 
                  background: PRIMARY_BROWN, 
                  borderRadius: '50%', 
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'center',
                  margin: '0 auto 16px auto',
                  color: NEUTRAL_WHITE,
                  fontSize: 20,
                  fontWeight: 700
                }}>
                  1
                </div>
                <h4 style={{ 
                  ...headingFont, 
                  fontSize: 16, 
                  color: NEUTRAL_TEXT, 
                  margin: '0 0 8px 0' 
                }}>
                  Download QR Code
                </h4>
                <p style={{ 
                  ...bodyFont, 
                  fontSize: 14, 
                  color: ACCENT_GRAY, 
                  margin: 0 
                }}>
                  Download your QR code in PNG or SVG format
                </p>
              </div>
              
              <div style={{ textAlign: 'center' }}>
                <div style={{ 
                  width: 48, 
                  height: 48, 
                  background: PRIMARY_BROWN, 
                  borderRadius: '50%', 
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'center',
                  margin: '0 auto 16px auto',
                  color: NEUTRAL_WHITE,
                  fontSize: 20,
                  fontWeight: 700
                }}>
                  2
                </div>
                <h4 style={{ 
                  ...headingFont, 
                  fontSize: 16, 
                  color: NEUTRAL_TEXT, 
                  margin: '0 0 8px 0' 
                }}>
                  Print & Display
                </h4>
                <p style={{ 
                  ...bodyFont, 
                  fontSize: 14, 
                  color: ACCENT_GRAY, 
                  margin: 0 
                }}>
                  Print and display at your shop, events, or marketing materials
                </p>
              </div>
              
              <div style={{ textAlign: 'center' }}>
                <div style={{ 
                  width: 48, 
                  height: 48, 
                  background: PRIMARY_BROWN, 
                  borderRadius: '50%', 
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'center',
                  margin: '0 auto 16px auto',
                  color: NEUTRAL_WHITE,
                  fontSize: 20,
                  fontWeight: 700
                }}>
                  3
                </div>
                <h4 style={{ 
                  ...headingFont, 
                  fontSize: 16, 
                  color: NEUTRAL_TEXT, 
                  margin: '0 0 8px 0' 
                }}>
                  Customers Scan
                </h4>
                <p style={{ 
                  ...bodyFont, 
                  fontSize: 14, 
                  color: ACCENT_GRAY, 
                  margin: 0 
                }}>
                  Customers scan to visit your storefront and place orders
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
